import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useUsersManager from "./hooks/useUsersManager";

import UsersStats from "./components/UsersStats";
import UsersToolbar from "./components/UsersToolbar";
import UsersTable from "./components/UsersTable";
import UserFormDrawer from "./components/UserFormDrawer";

export default function UsersManager() {
  useScrollToTop();

  const {
    sections,
    loading,
    saving,
    stats,
    query,
    selectedRole,
    selectedSection,
    visibleUsers,
    filteredUsers,
    visibleCount,
    drawer,
    demoMode,

    setQuery,
    setSelectedRole,
    setSelectedSection,
    resetFilters,
    loadMore,
    refreshData,

    openCreateDrawer,
    openEditDrawer,
    closeDrawer,
    handleCreateUser,
    handleUpdateUser,
    handleDeleteUser,
  } = useUsersManager();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <UsersToolbar
          query={query}
          selectedRole={selectedRole}
          selectedSection={selectedSection}
          sections={sections}
          loading={loading}
          demoMode={demoMode}
          onQueryChange={setQuery}
          onRoleChange={setSelectedRole}
          onSectionChange={setSelectedSection}
          onReset={resetFilters}
          onRefresh={refreshData}
          onCreate={openCreateDrawer}
        />

        <UsersStats stats={stats} />

        <UsersTable
          users={visibleUsers}
          sections={sections}
          loading={loading}
          totalRows={filteredUsers.length}
          visibleCount={visibleCount}
          demoMode={demoMode}
          onLoadMore={loadMore}
          onEdit={openEditDrawer}
          onDelete={handleDeleteUser}
        />
      </div>

      <UserFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        sections={sections}
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreateUser}
      />

      <UserFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        user={drawer.user}
        sections={sections}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdateUser}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}